import { OperatorDisplay, type OperatorsList } from '../../types'
import FilterActionIcon from './FilterActionIcon'

export function getOperatorDescription(
  operators: OperatorsList,
  type: string,
  currentOperator: string
) {
  const operatorFound =
    operators[type].find((item) => item.operator === currentOperator)?.des ||
    OperatorDisplay.Equals

  if (operatorFound === OperatorDisplay.Filteraction) {
    return <FilterActionIcon />
  }

  return operatorFound
}
